export const HOST = `https://awpshop-backend.onrender.com`